import * as React from "react"
import { SVGProps } from "react"

const IdCardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={72}
      height={46.667}
      viewBox="0 0 54 35"
      fill="currentColor"
      {...props}
    >
    <path d="M4.3 1C.7 2.5 0 5.3 0 17.8c0 17.8-1.8 16.7 27 16.7s27 1.1 27-17C54-.5 55.6.6 28.3.3 16.3.2 5.5.5 4.3 1zm44.5 4.2c1.7 1.7 1.7 22.9 0 24.6-1.7 1.7-41.9 1.7-43.6 0-1.7-1.7-1.7-22.9 0-24.6 1.7-1.7 41.9-1.7 43.6 0z" />
    <path d="M7 17.5v10.6l10.3-.3 10.2-.3v-20l-10.2-.3L7 6.9v10.6zm17 0V24H10V11h14v6.5zM30.2 9.7c.3 1.6 1.4 1.8 8.3 1.8 6.4 0 8-.3 8-1.5s-1.7-1.6-8.3-1.8c-7.6-.3-8.3-.1-8 1.5zM30 16.5c0 1.2 1.4 1.5 6.5 1.5s6.5-.3 6.5-1.5-1.4-1.5-6.5-1.5-6.5.3-6.5 1.5z" />
  </svg>
  );
};

export default IdCardIcon
